
<div class="card my-profile-form margin-top-20px">
  <div class="card-header wh-header card-title-schedule-bl padding-top-6px padding-bottom-6px">
    <div class="row margin-top-3px">
      <div class="col-md-3 padding-left-0px">
        Refunds
      </div>
      <div class="col-md-8 padding-right-0px">
        <div class="row">
          <div class="offset-md-4 col-md-2 text-align-right">
            <a *canUserAccess="['HL_BL_6']" (click)="AddRefund()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for Add Refund"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
          </div>
          <div class="col-md-3 col-sm-3 padding-right padding-left-0px">
            <div class="form-group  margin-bottom-5px">
              <div class="row">
                <div (click)="DecrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                  <a title="Previous" class="nav-link-hand">
                    <i class="fas fa-caret-left margin-top-3px font-size-24px"></i>
                  </a>
                </div>

                <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

                  <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
                </div>-->

                <div class="col-md-8 col-sm-4 padding-l-0px padding-right-9px">
                  <div class="date-form">
                    <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-24px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                           (ngModelChange)="dataChanged($event)">

                    <a (click)="d.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>



                </div>
                <div (click)="IncrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                  <a title="Next" class="nav-link-hand">
                    <i class="fas fa-caret-right margin-top-3px font-size-24px"></i>
                  </a>
                </div>
                <div class="col-md-1 padding-left-0px" hidden>
                  <a *canUserAccess="['HL_BL_6e']" class="nav-link-hand education-navlink data-color-new" title="print" (click)="printactivity()">
                    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                  </a>
                </div>
              </div>

            </div>
          </div>

          <div class="col-md-3 float-right padding-right-0px">
            <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="card-body padding-top-0px">
    <!--<div class="row margin-bottom-10px margin-top-10">
      <div class="col-md-8 padding-left-30px padding-right-0px">
        <div class="row">
          <div class="col-md-3">
            <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">

          </div>


        </div>
      </div>

    </div>-->

    <div class="row">
      <div class="col-md-12">
        <div class="table-component">
          <div class="table-responsive overflow-x">


            <table class="table table-striped margin-left-zero"
                   cols="auto,2*,*,*,*,*,*,*">

              <thead class="">
                <tr>

                  <th class="td-width-103px">
                    Code
                  </th>
                  <!--<th class="text-align-center">Day</th>-->
                  <!--<th class="">
                    PID
                  </th>-->
                  <th class="">Name</th>
                  <th class="">Request Date</th>
                  <th class="padding-right-0px">
                    Refundable
                  </th>
                  <th class="padding-right-0px">Requested Amt</th>
                  <th class="padding-right-0px">
                    Approved Amt
                  </th>
                  <th class="">
                    Paid Amt
                  </th>

                  <th class="">
                    Approved On
                  </th>
                  <th class="">
                    Paid On
                  </th>

                  <th class="">Status</th>

                  <th class=""></th>





                </tr>
              </thead>

              <tbody class="table-body">
                <tr *ngFor="let l of pdata">



                  <td class="td-padding-tb">
                    {{l.RefundCode}}
                  </td>
                  <!--<td>{{l.PatientFormattedCode}}</td>-->
                  <td class="td-padding-tb td-elipsis">
                    {{l.PatientName}}

                  </td>
                  <td class="td-padding-tb">

                    {{l.RefundRequestDate| date:'MMM-dd-yyyy'}}
                  </td>
                  <td class="text-align-right">{{l.RefundableAmount | number:'1.2-2'}}</td>
                  <td class="td-padding-tb text-align-right">{{l.RequestedAmount | number:'1.2-2'}}</td>
                  <td class="td-padding-tb text-align-right">
                    {{l.ApprovedAmount | number:'1.2-2'}}
                  </td>
                  <td class="td-padding-tb text-align-right">
                    {{l.RefundPaidAmount | number:'1.2-2'}}
                  </td>
                  <td class="td-padding-tb">

                    {{l.FirstLevelApprovedDate| date:'MMM-dd-yyyy'}}
                  </td>
                  <td class="td-padding-tb padding-right-0px">

                    {{l.RefundDate| date:'MMM-dd-yyyy'}}
                  </td>
                  <td class="td-padding-tb text-align-center">
                    <a data-toggle="tooltip" data-placement="bottom" title="Fully Paid" *ngIf="l.RefundStatus=='FP'">

                      <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                      </i>
                    </a>
                    <a data-toggle="tooltip" data-placement="bottom" title="Pending" *ngIf="l.RefundStatus=='Pending'">

                      <i class="fas fa-circle color-Assign  nav-link-hand font-size-14">
                      </i>
                    </a>

                    <!--<div [ngSwitch]="l.RefundStatus">
                      <div *ngSwitchCase="'FP         '" class="">
                        <i class="fa fa-check color-green "></i>
                      </div>
                      <div *ngSwitchCase="'Pending '" class="">
                        <i class="fa fa-check color-Assign"></i>

                      </div>

                    </div>-->
                    <!--{{l.RefundStatus}}-->
                    <!--<a data-toggle="tooltip" data-placement="bottom" title="Not Paid" *ngIf="l.BillStatus=='NP'">

                      <i class="fas fa-circle color-gray  nav-link-hand font-size-14">
                      </i>
                    </a>-->


                  </td>
                  <td class="td-padding-tb">

                    <a class="nav-link-hand education-navlink" title="To Refund Details" (click)="Open(l)">
                      <span class="badge">
                        <i class="fas fa-external-link-alt"></i>
                      </span>
                    </a>
                    <!--<div [ngSwitch]="l.RefundStatus">
                      <div *ngSwitchCase="'FP'" class="">
                        <i class="fas fa-circle color-green "></i>
                      </div>
                      <div *ngSwitchCase="'Pending'" class="">
                        <i class="fas fa-circle color-Assign"></i>

                      </div>

                    </div>-->
                    <!--{{l.RefundStatus}}-->
                    <!--<a data-toggle="tooltip" data-placement="bottom" title="Not Paid" *ngIf="l.BillStatus=='NP'">

                      <i class="fas fa-circle color-gray  nav-link-hand font-size-14">
                      </i>
                    </a>-->


                  </td>

                </tr>

              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<activitymonitoring [FormattedCode]='Selectedpatient.FormattedCode' [ActorCode]='Selectedpatient.ActorCode' *ngIf="ShowMonitoring"></activitymonitoring>
<router-outlet></router-outlet>
